import { Alert, Box, Typography } from '@mui/material';
import type { TruckBanCheck } from '../truckBans/truckBansApi';

/** Początek stałej uwagi o tranzycie z API (`TRANSIT_NOTE` w `truck-bans.ts`). */
export const TRANSIT_NOTE_START = 'Sprawdzamy tylko kraj załadunku i rozładunku';

/**
 * Zakazy ruchu ciężarówek przy zleceniu (19.10.2026; odpowiedź Marathonu
 * 16.10.2026 pyt. 11; przełącznik `truckBanCalendar`) — nad listą
 * rekomendacji, raz na zlecenie, bo okna załadunku i rozładunku są te same
 * dla każdego pojazdu. Ostrzeżenie, nie werdykt: lista, kolejność i „zdąży”
 * są takie same jak bez niego.
 *
 * Bez ostrzeżeń pokazujemy tylko uwagi o tym, czego nie sprawdzono (kraj
 * spoza kalendarza, dzień poza pokryciem) — sama stała uwaga o tranzycie
 * bez ostrzeżeń nie zajmuje miejsca. `check` brak = przełącznik wyłączony.
 */
export const TruckBanNote = ({ check }: { check: TruckBanCheck | null | undefined }) => {
  if (!check) return null;
  const gaps = check.notes.filter((n) => !n.startsWith(TRANSIT_NOTE_START));
  if (check.warnings.length === 0 && gaps.length === 0) return null;
  if (check.warnings.length === 0) {
    return (
      <Box sx={{ mb: 1 }} data-testid="truck-ban-gaps">
        {gaps.map((n) => (
          <Typography key={n} variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            Kalendarz zakazów: {n}
          </Typography>
        ))}
      </Box>
    );
  }
  return (
    <Alert severity="warning" sx={{ mb: 1 }} data-testid="truck-ban-warnings">
      {check.warnings.map((w) => (
        <Typography key={`${w.country}-${w.point}-${w.start}`} variant="body2">
          {w.text}
        </Typography>
      ))}
      {check.notes.map((n) => (
        <Typography key={n} variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {n}
        </Typography>
      ))}
    </Alert>
  );
};
